// extracted by mini-css-extract-plugin
export default {"centerText":"Dashboard_centerText__uvT4S"};